import React from "react";
import { Progress_bar } from "../dashboard/learn1";
import { Progress_bar2 } from "../dashboard/CompletedCourse";

export default function Courses(props) {
  const LearningStore = {
    enrolledCourses: [
      {
        course: {
          _id: "course1",
          title: "Introduction to JavaScript",
          image: "javascript_image_url",
        },
        createdAt: new Date(2023, 5, 15), // Example date
      },
      {
        course: {
          _id: "course2",
          title: "Advanced React Techniques",
          image: "react_image_url",
        },
        createdAt: new Date(2023, 3, 20), // Example date
      },
      {
        course: {
          _id: "course3",
          title: "Data Structures and Algorithms",
          image: "dsa_image_url",
        },
        createdAt: new Date(2023, 8, 10), // Example date
      },
      {
        course: {
          _id: "course1",
          title: "Introduction to JavaScript",
          image: "javascript_image_url",
        },
        createdAt: new Date(2023, 5, 15), // Example date
      },
      {
        course: {
          _id: "course2",
          title: "Advanced React Techniques",
          image: "react_image_url",
        },
        createdAt: new Date(2023, 3, 20), // Example date
      },
      {
        course: {
          _id: "course3",
          title: "Data Structures and Algorithms",
          image: "dsa_image_url",
        },
        createdAt: new Date(2023, 8, 10), // Example date
      },
      {
        course: {
          _id: "course1",
          title: "Introduction to JavaScript",
          image: "javascript_image_url",
        },
        createdAt: new Date(2023, 5, 15), // Example date
      },
      {
        course: {
          _id: "course2",
          title: "Advanced React Techniques",
          image: "react_image_url",
        },
        createdAt: new Date(2023, 3, 20), // Example date
      },
      {
        course: {
          _id: "course3",
          title: "Data Structures and Algorithms",
          image: "dsa_image_url",
        },
        createdAt: new Date(2023, 8, 10), // Example date
      },
      // Add more enrolled courses here as needed
    ],
    getTheCourseCompletionPercentage(courseId) {
      // Function to get the completion percentage of a course
      // Simulated implementation, replace with your logic
      return Math.floor(Math.random() * 100); // Random completion percentage
    },
  };
  function getRandomColor(index) {
    const colors = ["#f4f2ff", "#fff2ec", "#ecfbff"]; // Example colors
    return colors[index % colors.length];
  }

  // Function to generate a random font
  function getRandomFont(index) {
    const fonts = ["#8f7eed", "#ff5e18", "#0093cd"];
    const randomFontIndex = index % fonts.length;
    return fonts[randomFontIndex];
  }
  return (
    <div>
      <h1 className="text-primary font-bold text-xl px-5 md:px-14 pt-2 ">On Going Course</h1>
      <div className="mt-1 my-3 md:mx-8  lg:mx-8 w-[100%] ">
        <div className=" flex  py-3 overflow-x-auto no-scrollbar space-x-4 lg:space-x-10  w-[93%]">
          {props.course
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => (
              <Progress_bar
                label={enroll?.course?.title}
                score={LearningStore.getTheCourseCompletionPercentage(
                  enroll?.course?._id
                )}
                image={enroll?.course?.image}
                key={index}
                id={enroll?.course?._id}
                color={getRandomColor(index)}
                font={getRandomFont(index)}
              />
            ))}
        </div>
      </div>
      <h1 className="text-primary font-bold text-xl px-5 md:px-14 ">Completed Course</h1>
      <div className="mt-1 my-3 md:mx-8  lg:mx-8 w-[100%] ">
        <div className=" flex  py-3 overflow-x-auto no-scrollbar space-x-4 lg:space-x-10  w-[93%]">
          {props.course.isCourseCompleted && props.course
            .slice()
            .sort((a, b) => b.createdAt - a.createdAt)
            .map((enroll, index) => (
              <Progress_bar2
                label={enroll?.course?.title}
                score={100}
                image={enroll?.course?.image}
                key={index}
                id={enroll?.course?._id}
                color={getRandomColor(index)}
                font={getRandomFont(index)}
              />
            ))}
        </div>
      </div>
    </div>
  );
}
